// Helper timezone Europe/Rome per l'Agenda MasiAdvice CRM.
// Il DB e le API conservano/trasmettono timestamp UTC timezone-aware.
// Il frontend converte una sola volta prima della visualizzazione e prima del salvataggio.
// L'ora legale/solare italiana viene rispettata automaticamente via Intl con timeZone: "Europe/Rome".

export const APP_TZ = "Europe/Rome";

function romePartsOf(date) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: APP_TZ,
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
    hour12: false,
  }).formatToParts(date).reduce((a, p) => {
    if (p.type !== "literal") a[p.type] = p.value;
    return a;
  }, {});
}

// UTC ISO ("2026-07-24T22:18:00+00:00") -> "2026-07-25T00:18"  (input datetime-local, ora Rome)
export function utcIsoToLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const p = romePartsOf(d);
  const hour = p.hour === "24" ? "00" : p.hour;
  return `${p.year}-${p.month}-${p.day}T${hour}:${p.minute}`;
}

// "2026-07-25T00:18" (interpretato come Europe/Rome) -> "2026-07-24T22:18:00.000Z"
export function localInputToUtcIso(local) {
  if (!local) return null;
  const [dPart, tPart] = String(local).split("T");
  if (!dPart || !tPart) return null;
  const [y, m, d] = dPart.split("-").map(Number);
  const [hh, mm] = tPart.split(":").map(Number);
  if ([y, m, d, hh, mm].some(v => isNaN(v))) return null;

  // 1) Prendo l'istante "come se" l'input fosse già UTC
  const asIfUtcMs = Date.UTC(y, m - 1, d, hh, mm, 0);
  // 2) Guardo che ora è quell'istante nel fuso Rome
  const p = romePartsOf(new Date(asIfUtcMs));
  const romeHour = p.hour === "24" ? "00" : p.hour;
  const romeAsIfUtcMs = Date.UTC(+p.year, +p.month - 1, +p.day, +romeHour, +p.minute, +p.second);
  // 3) L'offset Europe/Rome per QUELL'istante (rispetta DST automaticamente)
  const offsetMs = romeAsIfUtcMs - asIfUtcMs;
  // 4) L'istante UTC reale è quello che, letto nel fuso Rome, produce le componenti immesse dall'utente
  return new Date(asIfUtcMs - offsetMs).toISOString();
}

// UTC ISO -> "YYYY-MM-DD" nel giorno civile Rome (evita off-by-one attorno a mezzanotte)
export function utcIsoToRomeYmd(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const p = romePartsOf(d);
  return `${p.year}-${p.month}-${p.day}`;
}

// UTC ISO -> componenti hh, mm in Rome (per drag&drop che preserva l'ora)
export function utcIsoToRomeHM(iso) {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return { hour: "00", minute: "00" };
  const p = romePartsOf(d);
  return { hour: p.hour === "24" ? "00" : p.hour, minute: p.minute };
}

// Formattazioni per la UI (sempre in Rome)
export function fmtRomeDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString("it-IT", {
    timeZone: APP_TZ,
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export function fmtRomeDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("it-IT", { timeZone: APP_TZ, day: "2-digit", month: "2-digit", year: "numeric" });
}

export function fmtRomeTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("it-IT", { timeZone: APP_TZ, hour: "2-digit", minute: "2-digit" });
}
